module.exports = __webpack_public_path__ + "img/nodata.b20a4d45.png";